import { z } from "zod";
import type { infer as zInfer } from "zod";

export const racingCompetitor = z.object({
  number: z.number(),
  name: z.string(),
  status: z.string().nullish(),
  startingPosition: z.string().nullish(),
  hcpDraw: z.string().nullish(),
  finishPosition: z.number().nullish(),
  age: z.string().nullish(),
  sex: z.string().nullish(),
  weight: z.string().nullish(),
  jockey: z.string().nullish(),
  trainer: z.string().nullish(),
  scratched: z.boolean().nullish(),
  scratchedAt: z.string().nullish(),
  emergency: z.boolean().nullish(),
  formAttributes: z.record(z.string(), z.string()),
  comment: z.string().nullish(),
  visible: z.boolean(),
  deductions: z.record(z.string(), z.number()).nullish(),
});

export type RacingCompetitor = zInfer<typeof racingCompetitor>;
